import React from 'react';
import { Activity } from 'lucide-react';
import TeamActivityTicker from '../../components/TeamActivityTicker';

export const meta = {
  id: 'team_activity',
  category: 'team',
  titleKey: 'dashboard.widgets.teamActivity',
  descriptionKey: 'dashboard.widgets.teamActivityDesc',
  defaultSize: 'xl',
  icon: Activity,
};

// Thin registry wrapper around the existing TeamActivityTicker so it can be
// moved/resized/removed like any other widget. The component self-gates by
// role and renders null when there's no recent activity.
export default function TeamActivityWidget() {
  return <TeamActivityTicker />;
}
